import React from 'react';
import Typography from '@mui/material/Typography';
import { MoneyType } from '../../propTypes/MoneyType';
import { formatMoney } from '../../helpers/money';

const MoneyCell = ({ amount, ...props }) => (
  <Typography variant="body2" align="left" noWrap width="inherit" {...props}>
    {formatMoney(amount, true)}
  </Typography>
);

MoneyCell.propTypes = {
  amount: MoneyType.isRequired,
};

export default MoneyCell;
